import { render } from "./BlockPrice.vue?vue&type=template&id=48659e51&scoped=true"
import script from "./BlockPrice.vue?vue&type=script&lang=js"
export * from "./BlockPrice.vue?vue&type=script&lang=js"

import "./BlockPrice.vue?vue&type=style&index=0&id=48659e51&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48659e51"]])

export default __exports__